module.exports = __webpack_public_path__ + "static/media/sx.58d97966.svg";